import { defaultShellConfig, type ShellConfig } from '@korvo/shell'

import { AppFooter } from '@/components/AppFooter'
import { AUTHENTICATED_SHELL_HOMEPAGE_PATH } from '@/config/authenticated-shell-home-path'

/**
 * Korvo main app shell configuration
 */
export const shellConfig: ShellConfig = {
  ...defaultShellConfig,
  metadata: {
    title: 'Project Korvo',
    description: 'Unified Workspace',
    favicon: '/pixkorvo.png',
  },
  branding: {
    appName: 'Project Korvo',
    brandingText: 'Access your workspace',
    copyrightText: '© 2025 Korvo. All rights reserved.',
  },
  routes: {
    homepage: AUTHENTICATED_SHELL_HOMEPAGE_PATH,
    signIn: '/auth/signin',
    register: '/auth/register',
    forgotPassword: '/auth/password/request',
    terms: '/terms',
    privacy: '/privacy',
  },
  routeManagement: {
    shellManaged: {
      admin: true, // All admin routes managed by shell
      appHome: true, // App home route managed by shell
      staticPages: false, // Keep existing terms/privacy pages
    },
    custom: [
      '/admin/settings/modules', // Module-specific admin routes (handled by [module]/[...path])
    ],
  },
  footer: {
    enabled: true,
    footerComponent: AppFooter,
  },
  topBar: {
    ...defaultShellConfig.topBar,
    /** Show global TopBar on `/workbench/[id]` workbench (profile, theme, notifications). */
    hideOnPathPrefixes: (defaultShellConfig.topBar?.hideOnPathPrefixes ?? []).filter(
      (prefix) => prefix !== '/workbench/',
    ),
    /**
     * Do not add `/projects` to pathPrefixesWithSideMenu: the shell drawer has no workbench-specific
     * extra content there, so the burger would only duplicate Home (UX_GUIDELINES — show Apps home
     * control in the topbar instead).
     */
  },
}

